import React from 'react'
import { Button } from '@mui/material'

const FadeFormTabPanel = ({ children, onSubmit }, ref) => {
  return (
    <form ref={ref} onSubmit={onSubmit}>
      <Button type="submit" sx={{ display: 'none' }} />
      {children}
    </form>
  )
}

export default React.forwardRef(FadeFormTabPanel)
